import React from 'react';
import { PageSection } from '../../../../Layout';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { IWorksheetComponent } from '../../../Core/types';
import { WorksheetAssociatedTestSection } from '../../../Core';
import { Field, TextOutput } from '../../../../Core';

const Section: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <PageSection heading="Laboratory Moisture Content">
      <WorksheetAssociatedTestSection
        name="EmbeddedMoistureContent.MoistureContentTest"
        testType="Moisture Content"
        heading="BS 1377-2:1990 Clause 3.2 Moisture"
        associatedTestModel={{
          measured: true,
        }}
      />
      <Field input={<TextOutput />} name="EmbeddedMoistureContent.LabDryDensity" label="Dry Density" />
    </PageSection>
  );
};

const BsEmbeddedMoistureContent = withInjectedProps(Section);

export { BsEmbeddedMoistureContent };
export default BsEmbeddedMoistureContent;
